export default __webpack_public_path__ + "static/media/Developer.6ac6013a.svg";